import { useQuery } from '@tanstack/react-query';
import { teamService } from '@/services/team/teamService';
import { teamKeys } from './queryKeys';
import type { DetailedTeamMember } from '@/services/team/types';

export const useTeamMemberProfile = (memberId: string | null) => {
  return useQuery({
    queryKey: teamKeys.memberProfile(memberId || ''),
    queryFn: () => teamService.getTeamMemberProfile(memberId!),
    enabled: !!memberId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
